/**
 * キーワードランキング＆アクセスランキングのタイトル
 */
export const RankingTitles = {
    DEFAULT: "ランキングタイトル",
    KEYWORD: "キーワードランキング",
    ACCESS: "アクセスランキング",
};

/**
 * 検索における、pid,db,それらに関連し使用しているiconの設定等
 */
export const PidSet = {
    201: {
        dbname: "JASI",
        tagname: "JASI",
        alt: "論文",
        icon: "li_document.png",
        type: "document",
        color: "color_01",
    },
    202: {
        dbname: "AGRIS",
        tagname: "AGRIS",
        alt: "論文",
        icon: "li_document.png",
        type: "document",
        color: "color_03",
    },
    203: {
        dbname: "AGROLib",
        tagname: "AGROLib",
        alt: "論文",
        icon: "li_document.png",
        type: "document",
        color: "color_02",
    },
    401: {
        dbname: "農林認定品種データベース",
        tagname: "認定品種",
        alt: "認定品種",
        icon: "li_image.png",
        type: "image",
        color: "color_06",
    },
    402: {
        dbname: "農機具データベース",
        tagname: "農機具",
        alt: "農機具",
        icon: "li_image.png",
        type: "image",
        color: "color_07",
    },
    // 未定義のpidに対するデフォルト値
    default: {
        dbname: "",
        tagname: "",
        alt: "",
        icon: "li_document.png",
        type: "document",
        color: "",
    },
};

/**
 * フォームのバリデーションで使用する設定値と違反した場合のメッセージ
 */
export const ValidationConstants = {
    INPUT_MAX_SIZE_128: {
        condition: 128,
        message: "128文字以下で入力してください。",
    },
    INPUT_MAX_SIZE_256: {
        condition: 256,
        message: "256文字以下で入力してください。",
    },
    INPUT_MAX_SIZE_1024: {
        condition: 1024,
        message: "1024文字以下で入力してください。",
    },
    DB_SELECT_REQUIRED: {
        condition: true,
        message: "データベースは1つ以上選択してください。",
    },
    INPUT_INTEGER_SIZE_8: {
        condition: /^([0-9a-zA-Z]{1,8})$/,
        message: "8桁以下の英数字で入力してください。",
    },
    INPUT_INTEGER_YEAR_4: {
        condition: /^([0-9]{1,4})$/,
        message: "西暦(半角数字)を入力してください。",
    },
};

/**
 * DispatchType
 */
export const DispatchType = {
    MENU_OPEN: "menuOpen",
    MENU_CLOSE: "menuClose",
    MENU_TOGGLE: "menuToggle",
    MODAL_OPEN: "modalOpen",
    MODAL_CLOSE: "modalClose",
    SET_MODAL: "setModal",
    SET_PAGE: "setPage",
};

/**
 * 書誌IDヘッダー
 */
export const AidHeader = {
    DOKUJI_ZASSHI: "AA",
    DOKUJI_TOSYO: "BB",
};